/* global $ */
$(document).ready(() => {
    const searchLink = $('#_search_link');
    searchLink.click(() => {
        searchLink.parent().toggleClass('show');

        if (searchLink.parent().hasClass('show')) {
            searchLink.parent().find('input[type="text"]').focus();
        }
    });
});
